var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CarouselIndex',{key:_setup.ids,attrs:{"title":_vm.$t('general.newestListHeading'),"subtitle":_vm.$t('general.newestListDesc'),"nfts":_setup.nfts,"action-type":"link","link-url":`/${_setup.urlPrefix}/explore/items/?search=&sort=updatedAt_DESC`,"link-text":_vm.$t('helper.seeMore')}})
}
var staticRenderFns = []

export { render, staticRenderFns }